var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTympanaDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1669.1 374.7",
    style: {
      enableBackground: "new 0 0 1669.1 374.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#182a52}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M438.5 150.8h-43.8c-2.1 0-3.7-1.7-3.7-3.7v-31.2c0-2.1 1.7-3.7 3.7-3.7h140.2c2.1 0 3.7 1.7 3.7 3.7V147c0 2.1-1.7 3.7-3.7 3.7h-43.8c-2.1 0-3.7 1.7-3.7 3.7v140.7c0 2.1-1.7 3.7-3.7 3.7H446c-2.1 0-3.7-1.7-3.7-3.7V154.5c-.1-2.1-1.8-3.7-3.8-3.7zM636.5 155.6h35.2c2.1 0 3.7 1.7 3.7 3.7v112.2c0 50.7-13.9 81-72 81-8.6 0-25.4-1.5-34.8-5-1.4-.5-2.3-1.9-2.3-3.5v-24.7c0-2.4 2.3-4.2 4.6-3.6 7.7 1.9 15.8 2.8 25.4 2.8 30.3 0 38.6-17.4 38.6-47h-.2c-6.6 12.4-19.7 17.7-34.8 17.7-30.5 0-51.8-21-51.8-59.1v-70.7c0-2.1 1.7-3.7 3.7-3.7H587c2.1 0 3.7 1.7 3.7 3.7V230c0 15.4 6.1 24 20.7 24s21.2-8.6 21.2-24v-70.7c.2-2.1 1.9-3.7 3.9-3.7zM706.3 295.2V159.3c0-2.1 1.7-3.7 3.7-3.7h28.2c1.8 0 3.4 1.3 3.7 3.1l1.7 9.9c.6 3.3 4.8 4.2 6.7 1.5 8-10.9 20.3-17.5 37.2-17.5s30.7 7 37.9 20c1.3 2.4 4.7 2.7 6.3.4 9.9-13.7 24.4-20.5 41.9-20.5 33.6 0 52.5 19.2 52.5 58.6v84.1c0 2.1-1.7 3.7-3.7 3.7h-35.2c-2.1 0-3.7-1.7-3.7-3.7v-84.1c0-14.9-7.6-22.5-21.5-22.5-16.9 0-24.5 7.6-24.5 29.5v77.1c0 2.1-1.7 3.7-3.7 3.7h-35.2c-2.1 0-3.7-1.7-3.7-3.7v-84.1c0-14.9-7.6-22.5-21.5-22.5-16.9 0-24.5 7.6-24.5 29.5v77.1c0 2.1-1.7 3.7-3.7 3.7H710c-2 .1-3.7-1.6-3.7-3.7zM1100.9 223.2c0 49-29.3 78.8-73 78.8-8.9 0-17.2-.5-24.8-1.6-2.2-.3-4.2 1.4-4.2 3.7v41.7c0 2.1-1.7 3.7-3.7 3.7H960c-2.1 0-3.7-1.7-3.7-3.7V159.3c0-2.1 1.7-3.7 3.7-3.7h28.2c1.8 0 3.4 1.3 3.7 3.1l2 11.2c.6 3.2 4.7 4.2 6.7 1.5 8.1-10.8 21.5-18.8 43.5-18.8 34.8-.1 56.8 31 56.8 70.6zm-44.7.3c0-20.7-6.8-35.6-31.1-35.6-18.7 0-26.3 15.2-26.3 29.3v45.7c0 1.7 1.1 3.1 2.8 3.6 5.8 1.7 11.9 2.4 18.7 2.4 25.8 0 35.9-19.7 35.9-45.4zM1284.7 266.7v22.2c0 .9-.3 1.8-1 2.5-6.9 7.1-19.9 10.5-28.3 10.5-14.8 0-25.6-5.8-31.7-16.4-1.3-2.3-4.5-2.6-6.2-.5-7.9 9.8-20 16.9-39.1 16.9-42.9 0-62.4-29.5-62.4-74.5s28.3-75 72.5-75c14.3 0 27.6 3 39.3 7.5 1.8.7 3.8-.1 4.7-1.9l.2-.5c.6-1.3 1.9-2.1 3.4-2.1h20.7c2.1 0 3.7 1.7 3.7 3.7V253c0 10.1 4.8 12.9 10.1 12.9 3.2 0 5.8-.7 8.5-2.3 2.4-1.5 5.6.2 5.6 3.1zm-66.9-29.3V195c0-1.5-.9-3-2.4-3.5-6.7-2.4-14-3.6-21.8-3.6-22.7 0-32.8 17.4-32.8 39.6 0 24.2 8.8 39.1 30.3 39.1 18.8.1 26.7-15.1 26.7-29.2zM1304.6 155.6h28.2c1.8 0 3.4 1.3 3.7 3.1l1.8 10.3c.6 3.2 4.7 4.2 6.6 1.6 8.5-11.1 21.6-18 38.7-18 32.6 0 50.5 19.2 50.5 58.6v84.1c0 2.1-1.7 3.7-3.7 3.7h-35.2c-2.1 0-3.7-1.7-3.7-3.7v-84.1c0-14.9-7.6-22.5-21.5-22.5-16.9 0-26.5 7.6-26.5 29.5v77.1c0 2.1-1.7 3.7-3.7 3.7h-35.2c-2.1 0-3.7-1.7-3.7-3.7v-136c-.1-2 1.6-3.7 3.7-3.7zM1625 266.7v22.2c0 .9-.3 1.8-1 2.5-6.9 7.1-19.9 10.5-28.3 10.5-14.8 0-25.6-5.8-31.7-16.4-1.3-2.3-4.5-2.6-6.2-.5-7.9 9.8-20 16.9-39.1 16.9-42.9 0-62.4-29.5-62.4-74.5s28.3-75 72.5-75c14.3 0 27.6 3 39.3 7.5 1.8.7 3.8-.1 4.7-1.9l.2-.5c.6-1.3 1.9-2.1 3.4-2.1h20.7c2.1 0 3.7 1.7 3.7 3.7V253c0 10.1 4.8 12.9 10.1 12.9 3.2 0 5.8-.7 8.5-2.3 2.4-1.5 5.6.2 5.6 3.1zm-66.9-29.3V195c0-1.5-.9-3-2.4-3.5-6.7-2.4-14-3.6-21.8-3.6-22.7 0-32.8 17.4-32.8 39.6 0 24.2 8.8 39.1 30.3 39.1 18.9.1 26.7-15.1 26.7-29.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.705,
    y1: 375.467,
    x2: 422.145,
    y2: 0.847,
    gradientTransform: "matrix(1 0 0 -1 0 374.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#66ddc0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0052a3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M302.1 0c-97.2 0-176.2 79.1-176.2 176.2v148.9c0 27.3 22.2 49.5 49.5 49.5s49.5-22.2 49.5-49.5V176.2c0-42.6 34.6-77.2 77.2-77.2 27.4 0 49.5-22.2 49.5-49.5S329.4 0 302.1 0z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002353942690416557510000001236878702066899635_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.549,
    y1: 381.211,
    x2: 427.989,
    y2: 6.601,
    gradientTransform: "matrix(1 0 0 -1 0 374.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#66ddc0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0052a3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002353942690416557510000001236878702066899635_)"
    },
    d: "M199.1 0H50.6C21.9 0-1.6 23.9.1 52.5 1.7 78.5 23.2 99 49.5 99h66.2c2.3 0 4.4-1.4 5.4-3.5 16.8-37.2 44.8-68.3 79.7-89 3.1-1.8 1.8-6.5-1.7-6.5z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1636.7 142.9v4.2h-8.1v21.2h-5v-21.2h-8.1v-4.2h21.2zm27.4 25.4-.9-14.9c-.1-2-.1-4.4-.2-7.1h-.3c-.7 2.2-1.4 5.2-2.2 7.5l-4.6 14.1h-5.2l-4.6-14.5c-.5-2-1.2-4.9-1.8-7.2h-.3c0 2.3-.1 4.8-.2 7.1l-.9 14.9h-4.8l1.9-25.4h7.6l4.4 12.4c.6 2 1 3.8 1.7 6.4h.1c.7-2.3 1.2-4.5 1.8-6.3l4.4-12.5h7.3l2 25.4-5.2.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTympanaDark);
export default __webpack_public_path__ + "static/media/tympana-dark.565d466d66636926daf716f0b8497bcf.svg";
export { ForwardRef as ReactComponent };